<aside
    [@expandCollapseSidebar]="isExpand() ? 'expand' : 'collapse'"
    class="flex max-h-full min-h-full flex-col bg-white mb:absolute mb:left-0 mb:top-0 mb:z-50 mb:hidden mb:w-[264px]"
    aria-labelledby="sidebar"
>
    <!-- w-24 -->
    <div class="h-[109px] shrink-0 p-6 mb:hidden">
        <div
            class="flex flex-row items-center"
            [ngClass]="{
                'justify-between': isExpand(),
                'justify-center': !isExpand(),
            }"
        >
            <h1
                class="overflow-hidden whitespace-nowrap text-2xl font-bold leading-9 text-neutral-09"
                [ngClass]="{ 'w-0': !isExpand() }"
            >
                BOOKING CMS
            </h1>
            <button
                (click)="handleOpenMenu()"
                [pnOverlay]="sidebarTemplate"
                overlayType="sideBarLeft"
                [(open)]="sidebarVisible"
                [disabledOverlay]="desktopBreakpoint()"
            >
                <svg-icon
                    class="cursor-pointer transition-all duration-[0.15s] ease-in"
                    [ngClass]="isExpand() ? '!rotate-0' : 'rotate-180'"
                    src="/assets/icons/expand.svg"
                ></svg-icon>
            </button>
        </div>
    </div>
    <pn-menu [expanded]="isExpand()" [overlayVisible]="sidebarVisible()" />
</aside>

<ng-template #sidebarTemplate>
    <aside class="flex max-h-full min-h-full w-[264px] flex-col bg-white" aria-labelledby="sidebar">
        <!-- w-24 -->
        <div class="h-[109px] shrink-0 p-6 mb:hidden">
            <div class="flex flex-row items-center justify-between">
                <h1
                    class="overflow-hidden whitespace-nowrap text-2xl font-bold leading-9 text-neutral-09"
                >
                    BOOKING CMS
                </h1>
                <button (click)="sidebarVisible.set(false)" type="button">
                    <svg-icon
                        class="rotate-180 transition-all duration-[0.15s] ease-in"
                        src="/assets/icons/expand.svg"
                    ></svg-icon>
                </button>
            </div>
        </div>
        <div class="hidden justify-end px-5 py-2 mb:flex">
            <button (click)="sidebarVisible.set(false)" type="button">
                <svg-icon
                    [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
                    src="/assets/icons/close.svg"
                ></svg-icon>
            </button>
        </div>
        <pn-menu />
    </aside>
</ng-template>
